module.exports = __webpack_public_path__ + "img/Tax Payment.9b983ee3.svg";